import type React from 'react';

import classNames from 'classnames';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { TranscriptIcon } from '../../icons/transcript';
import { Tooltip } from '../tooltip/tooltip';

import styles from './transcript-menu-button.module.css';

export const TranscriptMenuButtonName = 'transcript-menu-button';

type Props = {
  isActive?: boolean;
  className?: string;
  onClick?: () => void;
};

export function TranscriptMenuButton({ isActive, className, onClick }: Props) {
  const { t } = useTranslation();

  const label = isActive ? t('ui.transcript.menu.button.label.active') : t('ui.transcript.menu.button.label.inactive');
  const button = useCallback(
    (ref: React.LegacyRef<HTMLButtonElement>, props: Record<string, unknown>) => (
      <button
        data-testid={TranscriptMenuButtonName}
        type="button"
        name={TranscriptMenuButtonName}
        aria-expanded={isActive}
        aria-haspopup="true"
        className={classNames(styles.button, className)}
        onClick={onClick}
        ref={ref}
        {...props}
      >
        <TranscriptIcon />
      </button>
    ),
    [className, isActive, onClick]
  );
  return <Tooltip tooltip={label} trigger={button} />;
}
